import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import InertiaPlugin from 'gsap/InertiaPlugin';

export function initGalleryCarousel() {
	gsap.registerPlugin(InertiaPlugin, Draggable);
	let carouselBlocks = document.querySelectorAll('.carousel-blocks');

	carouselBlocks.forEach((carousel) => {
		let carouselBlocksObserver = null;
		let slides = carousel.querySelectorAll('.slide');
		let numSlides = slides.length;
		let mobileImagesLoaded = false;
		let initialized = false;

		gsap.set(slides, { xPercent: (i) => i * 100 });

		let wrap = gsap.utils.wrap(-100, (numSlides - 1) * 100);
		let wrapProgress = gsap.utils.wrap(0, 1);
		let proxy = document.createElement('div');
		let slideWidth = 0;
		let wrapWidth = 0;
		let animation = gsap.timeline({ repeat: -1 });

		let draggable = new Draggable(proxy, {
			trigger: '.slides-container',
			type: 'x',
			inertia: true,
			throwResistance: 500,
			onPressInit: function () {
				carousel.classList.add('dragging');
				animation.pause();
				updateProgress();

				if (!mobileImagesLoaded) {
					if (window.innerWidth <= 768) {
						let images =
							carousel.querySelectorAll('.mobile-image.lazy');

						images.forEach((image) => {
							if (image.getAttribute('data-src') != '') {
								image.src = image.getAttribute('data-src');
								image.removeAttribute('data-src');
							}
						});

						mobileImagesLoaded = true;
					}
				}
			},
			onRelease: function () {
				carousel.classList.remove('dragging');
			},
			onDrag: updateProgress,
			onThrowUpdate: updateProgress,
			onThrowComplete: function () {
				autoPlay();
			},
		});

		function autoPlay() {
			if (draggable.getDirection() == 'left' || !initialized) {
				animation.play().reverse();
				initialized = true;
				return;
			}
			animation.play();
		}

		function updateProgress() {
			animation.progress(
				wrapProgress(gsap.getProperty(proxy, 'x') / wrapWidth)
			);
		}

		function resize() {
			let progress = animation.progress();
			slideWidth = slides[0].offsetWidth;
			wrapWidth = slideWidth * numSlides;

			animation
				.progress(0)
				.clear()
				.to(slides, {
					duration: 100,
					xPercent: '+=' + numSlides * 100,
					ease: 'none',
					modifiers: {
						xPercent: wrap,
					},
				})
				.to(proxy, { x: wrapWidth, duration: 100, ease: 'none' }, 0)
				.progress(progress)
				.reverse(0);
		}

		function blockIntersectionObserver() {
			const config = {
				root: null,
				rootMargin: '0px',
				threshold: 0,
			};

			carouselBlocksObserver = new IntersectionObserver(function (
				entries
			) {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						autoPlay();
					} else {
						animation.pause();
						updateProgress();
					}
				});
			}, config);

			if ('IntersectionObserver' in window) {
				carouselBlocks.forEach((block) => {
					carouselBlocksObserver.observe(block);
				});
			}
		}

		//window.addEventListener('resize', resize);
		blockIntersectionObserver();
		resize();
		animation.pause();
		updateProgress();
	});
}
